import { api } from './api';

export async function getRaw (url, values) {
  return await api('GET', url, values);
}

export async function postRaw (url, values) {
  return await api('POST', url, values);
}

export async function putRaw (url, values) {
  return await api('PUT', url, values);
}

export async function patchRaw (url, values) {
  return await api('PATCH', url, values);
}

export async function deleteRaw (url, values) {
  return await api('DELETE', url, values);
}
